<div class="form-group">

    <input #fileInput class="file-input" type="file" [accept]="acceptedTypes" (change)="handleFileInput($event.target.files[0])">
    <mat-icon class="input-icon">folder</mat-icon>
</div>

